import { createContext } from 'react'

export const CalendarContext = createContext({
  onChangeTaskStatus: null,
  onOpenRelieveDay: null,
  onOpenTask: null,
})
